<app-example-format
  [codeHtmlPath]="'code/examples/example-measure/example-measure/example-measure.component.html'"
  [codeScssPath]="'code/examples/example-measure/example-measure/example-measure.component.scss'"
  [codeTypescriptPath]="'code/examples/example-measure/example-measure/example-measure.component.ts'"
  [kaartConfigFilePath]="'code/examples/example-measure/example-measure/kaartconfig.json'"
  [title]="componentInfo.title"
  urlChangelog=""
  urlCodeHtml="example-draw/example-measure/example-measure/example-measure.component.html"
  urlCodeScss="example-draw/example-measure/example-measure/example-measure.component.scss"
  urlCodeTypescript="example-draw/example-measure/example-measure/example-measure-.component.ts"
  urlGitHub=""
  urlKaartConfig="example-measure/kaartconfig.json"
  urlTSDocs=""
  urlTreeConfig=""
  urlVoorbeelden=""
>
  @if (componentInfo.tags && componentInfo.tags?.length > 0) {
    <div page-labels>
      @for (tag of componentInfo.tags; track tag) {
        <span class="badge bg-primary mx-1">{{ tag.toLocaleLowerCase() }}</span>
      }
    </div>
  }

  <div page-introduction>
    <p>{{ componentInfo.introduction }}</p>
    <p>
      Instelmogelijkheden voor meten met behulp van <code>drawOptions</code>:
      <br />- Lengte van elk segment tonen (<code>showSegmentLength</code>)
      <br />- Totale lengte van alle segmenten tonen
      (<code>showTotalLength</code>) <br />- Oppervlakte van een polygoon tonen
      (<code>showArea</code>)
    </p>
    <p>
      In onderstaand voorbeeld worden bij het tekenen van een lijn de
      segmentlengte en totale lengte getoond. Bij het tekenen van een polygoon
      worden de segmentlengte en oppervlakte getoond.
    </p>
  </div>

  <div page-functionality>
    <div class="row">
      <!-- DOCS:START functionality -->
      <div class="col-md-3 col-sm-6">
        <div>
          <b>Meten</b>
          <div class="d-flex flex-column align-items-stretch">
            <button
              [class.active]="measuring() === mapComponentDrawTypes.LINESTRING"
              (click)="measureLine()"
            >
              Lijn tekenen en meten
            </button>
            <button
              [class.active]="measuring() === mapComponentDrawTypes.POLYGON"
              (click)="measurePolygon()"
            >
              Polygon tekenen en meten
            </button>
            <hr />
            <button (click)="stopMeasureManual()">
              Tekenen en meten afronden
            </button>
          </div>
        </div>
      </div>
      <div class="col-md-6 col-sm-10">
        <div class="map-container">
          <ggc-map
            [mapIndex]="mapIndex"
            [webServices]="mapConfig"
            [minZoomlevel]="6"
          ></ggc-map>
        </div>
      </div>
      <!-- DOCS:END functionality -->
    </div>
  </div>
</app-example-format>
